// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"365":"3eefe47d","453":"ce4e7d83"}[chunkId] + ".chunk.js";
};